import { FormattedMessage } from 'react-intl';
import messages from './messages';

type ShiftApplicationRecommendationMessageProps = {
  publisher: {
    isShiftLeader: boolean;
    gender: string;
  };
  hasAppliedTeamLead: boolean;
  numberOfMissingApplicationsForOneRouteToTakePlace: number;
  numberOfMissingBrothersForOneRouteToTakePlace: number;
};

export const ShiftApplicationRecommendationMessage = (
  props: ShiftApplicationRecommendationMessageProps
) => {
  if (props.publisher.isShiftLeader && !props.hasAppliedTeamLead) {
    return <FormattedMessage {...messages.missingTeamLead} />;
  }
  if (
    props.publisher.gender === 'Male' &&
    props.numberOfMissingBrothersForOneRouteToTakePlace > 0
  ) {
    return (
      <FormattedMessage
        {...messages.missingBrothers}
        values={{
          numberOfMissingBrothers:
            props.numberOfMissingBrothersForOneRouteToTakePlace,
        }}
      />
    );
  }
  if (props.numberOfMissingApplicationsForOneRouteToTakePlace > 0) {
    return (
      <FormattedMessage
        {...messages.missingPublishers}
        values={{
          numberOfMissingPublishers:
            props.numberOfMissingApplicationsForOneRouteToTakePlace,
        }}
      />
    );
  }
  return null;
};
